import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-33a1b9b9")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_el_tabs = _resolveComponent("el-tabs")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_tabs, {
      modelValue: _ctx.activeName,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeName = $event)),
      onTabClick: _ctx.changeTab
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabsData, (item) => {
          return (_openBlock(), _createBlock(_component_el_tab_pane, {
            name: item.name,
            key: item.name,
            label: item.label
          }, null, 8, ["name", "label"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "onTabClick"]),
    (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tabsData[_ctx.activeName].component), {
      id: _ctx.id,
      uuid: _ctx.uuid,
      device: _ctx.deviceType,
      eventBus: _ctx.eventBus,
      onSettingThirdDeviceCount: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('settingThirdDeviceCount',$event)))
    }, null, 8, ["id", "uuid", "device", "eventBus"]))
  ]))
})